import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  height: fit-content;
  gap: 20px;
`;

// Container agrupado por familia. Substitui o Container flat — agora
// cada secao tem seu proprio header + grid de cards.
export const GroupedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  position: relative;
  padding-bottom: 20px;
`;

// Barra fixa de navegacao por categoria — chips que rolam ate cada secao.
// sticky no topo da area de scroll; rola horizontalmente se nao couber.
export const FamilyNav = styled.nav`
  position: sticky;
  top: 0;
  z-index: 6;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 0;
  margin-bottom: 8px;
  background: var(--cco-bg);
  border-bottom: 1px solid var(--cco-line);
`;

export const FamilyNavChip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid
    ${(props) => (props.$favorites ? 'var(--cco-orange)' : 'var(--cco-line)')};
  background: var(--cco-soft-surface);
  color: ${(props) =>
    props.$favorites ? 'var(--cco-orange)' : 'var(--cco-ink-mute)'};
  font-size: 11.5px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  transition: color 120ms, border-color 120ms;

  > .n {
    font-size: 10px;
    font-weight: 800;
    font-variant-numeric: tabular-nums;
    color: var(--cco-ink-faint);
  }

  &:hover {
    color: var(--cco-ink);
    border-color: var(--cco-line-strong);
  }
`;

export const FamilySection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

// Section header colapsavel: chevron + label + contador. Estilo flat
// (sem fundo nem borda), so border-bottom sutil para divisao visual.
export const FamilyHeader = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 6px 4px;
  background: transparent;
  border: none;
  border-bottom: 1px solid ${(props) => props.theme.colors.disabled};
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  transition: background 120ms ease;

  :hover {
    background: ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(0, 0, 0, 0.02)'
        : 'rgba(255, 255, 255, 0.03)'};
  }

  :focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.lightblue};
    outline-offset: 2px;
  }
`;

export const FamilyChevron = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.label};
  transition: transform 180ms ease;
  transform: rotate(${(props) => (props.$collapsed ? '0deg' : '90deg')});
  line-height: 1;
`;

export const FamilyLabel = styled.span`
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: ${(props) =>
    props.$favorites
      ? props.theme.colors.orange
      : props.theme.colors.darkerblue};
  flex: 1;
`;

export const FamilyCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  padding: 2px 8px;
  height: 20px;
  border-radius: 6px;
  background: ${(props) =>
    props.theme.title === 'light'
      ? 'rgba(0, 0, 0, 0.05)'
      : 'rgba(255, 255, 255, 0.07)'};
  color: ${(props) => props.theme.colors.label};
  font-size: 11px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
`;

export const FamilyGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Card = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
  padding: ${(props) => (props.selected ? '16px' : '0 16px')};
  width: 100%;
  min-height: ${(props) => (props.selected ? '350px' : '64px')};
  height: ${(props) => (props.selected ? 'auto' : '64px')};
  box-sizing: border-box;
  background: var(--cco-surface);
  border-radius: 12px;
  margin-bottom: 0;
  transition: all 270ms;
  border: 1px solid
    ${(props) =>
      props.favorite ? 'var(--cco-orange)' : 'var(--cco-line)'};
  /* Variavel em atencao/alarme: borda esquerda grossa colorida + leve glow
     pra destacar na parede de gauges. Favorito (laranja) e selecao seguem
     nas outras bordas. */
  ${(props) =>
    props.$alert &&
    props.$statusColor &&
    `
      border-left: 4px solid ${props.$statusColor};
      box-shadow: 0 0 0 1px ${props.$statusColor}33;
    `}
  ${(props) =>
    props.selected && 'box-shadow: 0 0 0 1px var(--cco-blue-soft);'}

  ${(props) => props.grayed && `opacity: 0.55`};

  img {
    cursor: pointer;
  }
  /* 
  @media (max-width: 1000px) {
    height: ${(props) => (props.selected ? '636px' : '275px')};
  } */
`;

export const Line = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  width: ${(props) => (props.selected ? '48%' : '100%')};
  height: 100%;
`;

export const VariableRow = styled.div`
  display: grid;
  grid-template-columns: 28px minmax(220px, 1fr) minmax(130px, 0.45fr) 130px 120px;
  gap: 16px;
  align-items: center;
  width: 100%;

  @media (max-width: 900px) {
    grid-template-columns: 28px minmax(140px, 1fr) auto auto;
  }
`;

export const VariableIdentity = styled.div`
  min-width: 0;
`;

export const VariableCode = styled.span`
  display: block;
  margin-top: 3px;
  overflow: hidden;
  color: var(--cco-ink-faint);
  font-size: 10px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ListValue = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 5px;
  font-variant-numeric: tabular-nums;

  .v {
    color: ${(props) => props.color || 'var(--cco-ink)'};
    font-size: 20px;
    font-weight: 800;
  }

  .u {
    color: var(--cco-ink-faint);
    font-size: 11px;
    font-weight: 700;
  }
`;

export const StatusCell = styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const NoData = styled.span`
  color: var(--cco-ink-faint);
  font-size: 11px;
  font-weight: 700;
`;

export const Checkbox = styled.div`
  width: 21px;
  height: 21px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid ${(props) => props.theme.colors.label};
  background: ${(props) =>
    props.selected ? props.theme.colors.label : 'transparent'};

  ::after {
    margin-left: 24px;
    line-height: 21px;
    content: 'Habilitado';
    font-weight: 900;
    font-size: 14px;
  }
`;

export const RangesWrapper = styled.div`
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  grid-template-columns: repeat(3, 3fr) 1fr;
  column-gap: 5px;
  place-items: center;
  row-gap: 5px;
  color: var(--cco-ink-mute);
  text-align: center;
  transition: all 270ms;
  overflow: hidden;

  -webkit-animation: grow 270ms; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: grow 270ms; /* Firefox < 16 */
  -ms-animation: grow 270ms; /* Internet Explorer */
  -o-animation: grow 270ms; /* Opera < 12.1 */
  animation: grow 270ms;

  @keyframes grow {
    from {
      width: 0px;
      height: 0px;
    }
    to {
      width: 100%;
      height: auto;
    }
  }

  h3 {
    border-radius: 8px;
    font-size: 10px;
    color: var(--cco-ink-mute);
    background: var(--cco-soft-surface);
  }
  input {
    border-radius: 8px;
    color: var(--cco-ink);
    background: var(--cco-soft-surface);
    border: 1px solid var(--cco-line);
    max-width: 80px;
  }
`;

export const GraficoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 16px;
  padding: 3px 6px;
  cursor: pointer;
  border-radius: 50%;
  background: var(--cco-soft-surface);
  display: grid;
  place-items: center;

  ::after {
    content: 'x';
    font-size: 10px;
    color: var(--cco-ink-mute);
  }
`;

export const Button = styled.button`
  text-align: center;
  padding: 4px 16px;
  font-size: 14px;
  font-weight: 700;
  border: 1px solid var(--cco-blue);
  color: var(--cco-blue);
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 270ms;
  :hover {
    background: var(--cco-blue);
    color: #fff;
  }
  ::after {
    content: '${(props) => props.label}';
  }
  :disabled {
    color: var(--cco-ink-faint);
    border-color: var(--cco-line);
    background: transparent;
    cursor: not-allowed;
  }
`;

export const FavoriteWrapper = styled.button`
  background: transparent;
`;

// Slot do botao "Configurar" (estado recolhido): escondido por padrao,
// aparece no hover/foco do card. Antes o botao ficava visivel nos ~60
// cards, virando uma parede de chrome repetido. A acao continua acessivel
// (teclado via focus-within) e o espaco e reservado pra nao "pular".
export const ConfigSlot = styled.div`
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
`;

export const Title = styled.label`
  font-size: 15px;
  font-weight: 800;
  display: block;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--cco-ink);
`;

export const Tag = styled.div`
  display: flex;
  padding: 2px 14px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #fff;
  background: ${(props) => props.color};
`;

export const Input = styled.input`
  text-align: center;
  padding: 3px 7px;
  color: var(--cco-ink);
`;

export const RangeTitle = styled.h3`
  text-align: center;
  color: ${(props) => props.color};
`;

export const Level = styled.label`
  color: ${(props) => props.theme.colors.label};
  font-size: 14px;
  text-align: center;
`;

export const ElevatedValue = styled.h3`
  border-radius: 10px;
  font-size: 18px;
  background: var(--cco-soft-surface);
  color: var(--cco-ink);
  padding: 5px 35px;
  border: 1px solid var(--cco-line);
`;

export const Period = styled(Tag)`
  width: auto;
  padding: 5px 20px;
  cursor: pointer;
  font-size: 14px;
  color: ${(props) => (props.selected ? '#fff' : 'var(--cco-ink-mute)')};
  transition: all 270ms;

  ${(props) =>
    props.selected
      ? `background: ${
          props.color === 'blue' ? 'var(--cco-blue)' : 'var(--cco-orange)'
        };`
      : `background: var(--cco-soft-surface)`}

  :hover {
    ${(props) =>
      `background: ${
        props.color === 'blue' ? 'var(--cco-blue)' : 'var(--cco-orange)'
      };`}
    color: #fff;
  }
`;

export const BooleanValue = styled.label`
  font-size: 16px;
  font-weight: 800;
`;

// Escala min/max sob o gauge — referencia numerica das faixas coloridas.
export const GaugeScale = styled.div`
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: -6px auto 0;
  font-size: 10px;
  font-weight: 600;
  color: var(--cco-ink-faint);
  font-variant-numeric: tabular-nums;
`;

// Valor "stat" (sem gauge): pra variaveis cumulativas/codigos/setpoints
// onde a agulha nao significa nada (Energia kWh, Horimetro, Codigo,
// Feedback...). Ocupa o mesmo espaco vertical do gauge pra manter o card
// alinhado na grid. Numero grande + unidade discreta, cor por status.
export const StatValue = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 130px;
  gap: 2px;

  > .v {
    font-size: 30px;
    font-weight: 800;
    line-height: 1.05;
    font-variant-numeric: tabular-nums;
    color: ${(props) => props.color || 'var(--cco-ink)'};
    text-align: center;
    word-break: break-word;
  }
  > .u {
    font-size: 12px;
    font-weight: 600;
    color: var(--cco-ink-faint);
  }
`;

export const ClearFilter = styled.div`
  cursor: pointer;
  position: absolute;
  right: 8px;
  top: 8px;
  width: 25px;
  height: 25px;
  text-align: center;
  border-radius: 50%;
  background: var(--cco-soft-surface);
  color: var(--cco-ink-mute);
  :hover {
    transform: scale(1.05);
  }
  ::after {
    content: 'x';
    font-size: 14px;
  }
`;

export const DeleteButton = styled.button`
  width: 14px;
  height: 14px;
  outline: none;
  border-radius: 50%;
  background: transparent;
  color: var(--cco-ink-mute);
  border: 1px solid var(--cco-line-strong);
  cursor: pointer;

  ::after {
    content: 'X';
    font-size: 10px;
    display: grid;
    place-items: center;
    line-height: 10px;
  }
`;

export const AddButton = styled.button`
  width: 14px;
  height: 14px;
  outline: none;
  border-radius: 50%;
  background: transparent;
  color: var(--cco-ink-mute);
  border: 1px solid var(--cco-line-strong);
  cursor: pointer;

  ::after {
    content: '+';
    font-size: 10px;
    display: grid;
    place-items: center;
    line-height: 10px;
  }
`;

export const ItemList = styled.div`
  display: flex;
  width: 100%;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  color: ${(props) =>
    props.color === 'disabled' ? 'var(--cco-ink-faint)' : 'var(--cco-ink)'};
  padding: 6px 0;

  :hover {
    background: var(--cco-blue);
    color: #fff;
  }
`;

export const RangeListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--cco-surface);
  border: 1px solid var(--cco-line);
  border-radius: 8px;
  overflow: hidden;
`;
